import { render, staticRenderFns } from "./BackofficeDeleteUser.vue?vue&type=template&id=23c37640&"
import script from "./BackofficeDeleteUser.vue?vue&type=script&lang=js&"
export * from "./BackofficeDeleteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports